<template>
  <b-modal
    id="modal-1"
    :visible="showModal"
    @shown="populateData"
    class="testconfigmodal"
    centered
    hide-footer
    hide-header
    size="xl"
    no-close-on-backdrop
    @hidden="closeModal"
  >
    <b-overlay :show="showOverlay" rounded="sm">
      <div class="d-flex tc-modal-body">
        <div class="cs-left-modal-back"></div>
        <div class="body-div-right-tc">
          <div class="p-3 mt-2 conf-form-head">
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex px-2">
                <div class="mr-3" @click="closeModal">
                  <img src="../../../assets/customfield/blueBackArrow.svg" />
                </div>
                <div class="modal-heading-form">
                  {{
                    configType === "view"
                      ? "Preview"
                      : configType === "add"
                      ? "Add"
                      : "Edit"
                  }}
                  Configuration
                </div>
              </div>
              <div
                @click="closeModal"
                class="xmark-modal-pos-tc rotate-on-hover pointer"
              >
                <img src="../../../assets/panelist/blue_cross.svg" alt="" />
              </div>
            </div>
          </div>
          <div class="mt-3 pan-log-tabs-tc">
            <b-tabs v-model="tabIndex" content-class="mt-3">
              <b-tab active>
                <template #title>
                  Opening Screen Display

                  <img
                    style="position: absolute; top: 15px"
                    v-b-popover.hover.top.v-danger="{
                      content: 'Please fill all the details',
                    }"
                    v-if="
                      dirtyCheckDescQuestion ||
                      $v.testConfigData.config.testOrg.$error ||
                      $v.testConfigData.config.testDesc.$error ||
                      $v.testConfigData.configName.$error ||
                      testoptError
                    "
                    src="../../../assets/img/config-modules/big-warning-red.svg"
                    alt=""
                  />
                  <div v-if="tabIndex == 0" class="tc-tab-sel"></div>
                </template>
                <div class="pr-2 configcontent-tabs-content px-5">
                  <b-row class="pb-1">
                    <b-col>
                      <div class="tc-form-fields mt-3 position-relative">
                        <label class="tc-form-labels"
                          >Configuration Name<span class="asterik"
                            >*</span
                          ></label
                        >
                        <b-form-input
                          class="mt-1"
                          type="text"
                          placeholder="Enter Here"
                          :disabled="configType == 'view'"
                          v-model.trim="$v.testConfigData.configName.$model"
                          :class="{
                            error: $v.testConfigData.configName.$error,
                          }"
                        ></b-form-input>
                        <div
                          style="position: absolute; top: 67px; left: 3px"
                          v-if="
                            $v.testConfigData.configName.$dirty &&
                            !$v.testConfigData.configName.required
                          "
                          v-b-popover.hover.top.v-danger="{
                            content: 'Required',
                          }"
                          variant="primary"
                          class="error-txt-tc"
                        >
                          Required
                        </div>
                        <div
                          style="position: absolute; top: 67px; left: 3px"
                          v-if="
                            !$v.testConfigData.configName.maxLength &&
                            $v.testConfigData.configName.required
                          "
                          variant="primary"
                          class="error-txt-tc"
                        >
                          Should not exceed 128 characters
                        </div>
                      </div>
                    </b-col>
                    <b-col>
                      <div class="tc-form-fields mt-3 relativeclass">
                        <label class="tc-form-labels"
                          >Test Organiser<span class="asterik">*</span></label
                        >
                        <b-form-input
                          class="mt-1"
                          id="input-1"
                          type="text"
                          placeholder="Enter Here"
                          :disabled="configType == 'view'"
                          v-model.trim="$v.testConfigData.config.testOrg.$model"
                          :class="{
                            error: $v.testConfigData.config.testOrg.$error,
                          }"
                        ></b-form-input>
                        <div
                          style="position: absolute; top: 66px; left: 3px"
                          v-if="
                            $v.testConfigData.config.testOrg.$dirty &&
                            !$v.testConfigData.config.testOrg.required
                          "
                          class="error-txt-tc"
                        >
                          Required
                        </div>
                        <div
                          style="position: absolute; top: 66px; right: 3px"
                          v-if="
                            !$v.testConfigData.config.testOrg.maxLength &&
                            $v.testConfigData.config.testOrg.required
                          "
                          class="error-txt-tc"
                        >
                          Should not exceed 120 characters
                        </div>
                      </div>
                    </b-col>
                    <b-col>
                      <div class="mt-3 tc-form-fields">
                        <label class="tc-form-labels"
                          >Test<span class="asterik">*</span></label
                        >
                        <div class="mt-1">
                          <SelectDropdown
                            :id="'access'"
                            :type="'filter'"
                            :dropdownOptions="testoptions"
                            :disableDropdown="configType == 'view'"
                            :value="selectOptions.value"
                            :placeholder="'Select'"
                            @setValue="setValue"
                            :showError="
                              testConfigData.config.test == '' && testoptError
                            "
                          />
                        </div>
                        <div
                          style="position: absolute; top: 83px; left: 19px"
                          v-if="
                            testoptError && testConfigData.config.test == ''
                          "
                          class="error-txt-tc"
                          variant="primary"
                        >
                          Required
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <div class="topDiv mt-4 relativeclass">
                        <label class="tc-form-labels"
                          >Test Description<span class="asterik">*</span></label
                        >
                        <div>
                          <QuillEditor
                            :addquesProp="addques1"
                            :value="$v.testConfigData.config.testDesc.$model"
                            :disableQuill="configType == 'view'"
                            @validationVal="validateText"
                            @questionText="updateQuestionContent"
                            @addquesBack="changedaddQues"
                            :showError="
                              dirtyCheckDescQuestion ||
                              (!$v.testConfigData.config.testDesc.maxLength &&
                                !dirtyCheckDescQuestion)
                            "
                          >
                          </QuillEditor>
                        </div>
                        <div
                          style="position: absolute; top: 5px; right: 12px"
                          v-if="
                            dirtyCheckDescQuestion &&
                            $v.testConfigData.config.testDesc.required
                          "
                          v-b-popover.hover.top.v-danger="{
                            content: 'Required',
                          }"
                          variant="primary"
                        ></div>
                        <div
                          style="position: absolute; top: 5px; right: 12px"
                          v-if="
                            !$v.testConfigData.config.testDesc.maxLength &&
                            !dirtyCheckDescQuestion
                          "
                          v-b-popover.hover.top.v-danger="{
                            content: 'Should not exceed 1024 characters',
                          }"
                          variant="primary"
                        ></div>
                        <div
                          style="position: absolute; top: 5px; right: 12px"
                          v-if="
                            dirtyCheckDescQuestion &&
                            !$v.testConfigData.config.testDesc.required
                          "
                          v-b-popover.hover.top.v-danger="{
                            content: 'Required',
                          }"
                          variant="primary"
                        ></div>
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <div class="d-flex tc-btnsDiv justify-content-end p-3">
                  <div class="add-btn-tc">
                    <b-button
                      class="h-32 w-87 ml-2"
                      v-if="configType == 'view'"
                      @click="enableEditing"
                    >
                      <span class="add-btn-tc-txt"> Edit</span>
                    </b-button>
                  </div>
                  <div class="cancelpan-btn" v-if="configType != 'view'">
                    <b-button @click="closeModal" class="h-32 w-87 ml-2"
                      >Cancel</b-button
                    >
                  </div>
                  <div class="add-btn-tc" v-if="configType != 'view'">
                    <b-button
                      @click="checkCondition(true)"
                      class="h-32 w-87 ml-4"
                      ><span class="add-btn-tc-txt">Next</span></b-button
                    >
                  </div>
                  <div class="cancelpan-btn" v-if="configType == 'view'">
                    <b-button
                      @click="checkCondition(true)"
                      class="h-32 w-87 ml-4"
                      ><span class="">Next</span></b-button
                    >
                  </div>
                </div>
              </b-tab>

              <b-tab>
                <template #title>
                  Question Behaviour
                  <img
                    style="position: absolute; top: 15px"
                    v-b-popover.hover.top.v-danger="{
                      content: 'Please fill all the details',
                    }"
                    v-if="
                      configType != 'view' &&
                      ($v.testConfigData.config.quesPerScreen.$error ||
                        $v.testConfigData.config.passingPercentage.$error ||
                        $v.testConfigData.config.negativeMarkValue.$error ||
                        $v.testConfigData.config.buffertime.$error ||
                        $v.testConfigData.config.timebnsel.$error ||
                        $v.testConfigData.config.timebnvalue.$error ||
                        $v.testConfigData.config.maxnoattempts.$error ||
                        $v.testConfigData.config.testDuration.$error ||
                        !$v.testConfigData.config.testDuration.between ||
                        $v.testConfigData.config.openTestdt.$error ||
                        (!$v.testConfigData.config.closeTestdt.isDateValid &&
                          testConfigData.config.closeTestdt != null) ||
                        $v.testConfigData.config.closeTestdt.$error)
                    "
                    src="../../../assets/img/config-modules/big-warning-red.svg"
                    alt=""
                  />
                  <div v-if="tabIndex == 1" class="tc-tab-sel"></div>
                </template>
                <div class="pr-2 configcontent-tabs-content px-5">
                  <b-row>
                    <b-col>
                      <div
                        class="w-100 tc-form-fields topDiv mt-3 relativeclass"
                      >
                        <label class="tc-form-labels"
                          >Start Test Date & Time
                          <span class="asterik">*</span></label
                        >
                        <div class="datepicker-tc position-relative">
                          <DatePicker
                            ref="startDate"
                            id="startdatetimeconfig"
                            class="
                              w-100
                              startdateconfig-tc
                              global-disabledField
                              mt-1
                            "
                            :class="{
                              'error-dp-tc':
                                configType != 'view' &&
                                ($v.testConfigData.config.openTestdt.$error ||
                                  timeDiffMinutes),
                            }"
                            placeholder="Enter here"
                            :disabled="configType == 'view'"
                            :format="dateDisplayFormat"
                            :value-type="dateValueFormat"
                            type="datetime"
                            :min-date="startdatetime"
                            :disabled-date="allowFromToday"
                            :disabled-time="disableTime"
                            v-model="testConfigData.config.openTestdt"
                          />
                        </div>
                        <img
                          class="calender-image-tc"
                          @click="openDate('startDate')"
                          :class="{ pointer: configType !== 'view' }"
                          src="../../../assets/img/config-modules/calendar-week.svg"
                          alt=""
                        />
                      </div>
                      <div
                        style="position: absolute; top: 86px; left: 22px"
                        v-if="
                          configType != 'view' &&
                          $v.testConfigData.config.openTestdt.$dirty &&
                          !$v.testConfigData.config.openTestdt.required
                        "
                        class="error-txt-tc"
                        variant="primary"
                      >
                        Required
                      </div>
                    </b-col>
                    <b-col>
                      <div
                        class="w-100 tc-form-fields topDiv mt-3 relativeclass"
                      >
                        <label class="tc-form-labels"
                          >End Test Date & Time<span class="asterik">*</span>
                        </label>
                        <DatePicker
                          ref="endDate"
                          id="input-1"
                          class="
                            w-100
                            startdateconfig-tc
                            global-disabledField
                            mt-1
                          "
                          :class="{
                            'error-dp-tc':
                              configType != 'view' &&
                              ($v.testConfigData.config.closeTestdt.$error ||
                                timeDiffMinutes ||
                                (!$v.testConfigData.config.closeTestdt
                                  .isDateValid &&
                                  testConfigData.config.closeTestdt != null)),
                          }"
                          placeholder="Enter here"
                          :disabled="
                            configType == 'view' ||
                            testConfigData.config.openTestdt == ''
                          "
                          :format="dateDisplayFormat"
                          :value-type="dateValueFormat"
                          type="datetime"
                          :min-date="minDate"
                          :disabled-date="allowPrevDates"
                          :disabled-time="disableTime"
                          v-model="testConfigData.config.closeTestdt"
                        />
                        <img
                          :class="{ pointer: configType !== 'view' }"
                          class="calender-image-tc"
                          @click="openDate('endDate')"
                          src="../../../assets/img/config-modules/calendar-week.svg"
                          alt=""
                        />
                      </div>
                      <template v-if="configType != 'view'">
                        <div
                          style="position: absolute; top: 86px; left: 22px"
                          v-if="
                            $v.testConfigData.config.closeTestdt.$dirty &&
                            !$v.testConfigData.config.closeTestdt.required
                          "
                          class="error-txt-tc"
                          variant="primary"
                        >
                          Required
                        </div>
                        <div
                          class="testtime-warning-box p-1 mt-1"
                          style="margin-top: 10px; padding: 8px"
                          v-if="
                            !$v.testConfigData.config.closeTestdt.isDateValid &&
                            testConfigData.config.closeTestdt != null
                          "
                        >
                          <img
                            src="../../../assets/testtimewarning.svg"
                            alt=""
                          />
                          End date/time cannot be earlier than the current
                          date/time.
                        </div>
                      </template>
                    </b-col>
                    <b-col>
                      <div class="tc-form-fields mt-3 relativeclass">
                        <label class="tc-form-labels"
                          >Test Duration(Minutes)<span class="asterik"
                            >*</span
                          ></label
                        >
                        <b-form-input
                          id="input-1"
                          class="mt-1"
                          placeholder="Enter Duration in Minutes"
                          type="text"
                          :disabled="configType == 'view'"
                          v-model="$v.testConfigData.config.testDuration.$model"
                          @keypress="validateInput($event)"
                          :class="{
                            error:
                              $v.testConfigData.config.testDuration.$error ||
                              !$v.testConfigData.config.testDuration.between,
                          }"
                        ></b-form-input>
                        <div
                          style="position: absolute; top: 67px; left: 6px"
                          v-if="
                            $v.testConfigData.config.testDuration.$dirty &&
                            !$v.testConfigData.config.testDuration.required
                          "
                          class="error-txt-tc"
                          variant="primary"
                        >
                          Required
                        </div>
                        <div
                          style="position: absolute; top: 67px; left: 6px"
                          v-else-if="
                            !$v.testConfigData.config.testDuration.between &&
                            $v.testConfigData.config.testDuration.required &&
                            $v.testConfigData.config.testDuration.numeric
                          "
                          class="error-txt-tc"
                          variant="primary"
                        >
                          Should be between 5 to 360
                        </div>
                        <div
                          style="position: absolute; top: 67px; left: 6px"
                          v-else-if="
                            !$v.testConfigData.config.testDuration.numeric &&
                            $v.testConfigData.config.testDuration.required
                          "
                          class="error-txt-tc"
                          variant="primary"
                        >
                          Enter a valid value
                        </div>
                        <div
                          class="testtime-warning-box p-1 mt-1"
                          style="margin-top: 10px; padding: 8px"
                          v-else-if="
                            timeDiffMinutes &&
                            !$v.testConfigData.config.testDuration.invalid
                          "
                        >
                          <img
                            src="../../../assets/testtimewarning.svg"
                            alt=""
                          />
                          The difference between end time and start time cannot
                          be less than the test duration.
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2">
                    <b-col>
                      <div class="tc-form-fields mt-3 relativeclass">
                        <label class="tc-form-labels"
                          >Passing Percentage<span class="asterik"
                            >*</span
                          ></label
                        >
                        <b-form-input
                          id="input-1"
                          type="text"
                          class="mt-1"
                          placeholder="Enter Here"
                          v-model.trim="
                            $v.testConfigData.config.passingPercentage.$model
                          "
                          @keypress="validateInput($event)"
                          :class="{
                            error:
                              $v.testConfigData.config.passingPercentage.$error,
                          }"
                          :disabled="configType == 'view'"
                        ></b-form-input>
                        <div
                          style="position: absolute; top: 67px; left: 8px"
                          v-if="
                            $v.testConfigData.config.passingPercentage.$dirty &&
                            !$v.testConfigData.config.passingPercentage.required
                          "
                          class="error-txt-tc"
                        >
                          Required
                        </div>
                        <div
                          style="position: absolute; top: 67px; left: 8px"
                          v-else-if="
                            !$v.testConfigData.config.passingPercentage
                              .numeric &&
                            $v.testConfigData.config.passingPercentage.required
                          "
                          class="error-txt-tc"
                          variant="primary"
                        >
                          Not valid number
                        </div>
                        <div
                          style="position: absolute; top: 67px; left: 8px"
                          v-else-if="
                            !$v.testConfigData.config.passingPercentage
                              .between &&
                            $v.testConfigData.config.passingPercentage.required
                          "
                          class="error-txt-tc"
                          variant="primary"
                        >
                          Should be between 1 to 100
                        </div>
                      </div>
                    </b-col>
                    <b-col>
                      <div class="tc-form-fields mt-3 position-relative">
                        <label class="tc-form-labels"
                          >Number of Questions Per Screen
                          <span class="asterik">*</span></label
                        >
                        <b-form-input
                          type="text"
                          placeholder="Enter Here"
                          class="mt-1"
                          v-model.trim="
                            $v.testConfigData.config.quesPerScreen.$model
                          "
                          @keypress="validateInput($event)"
                          :class="{
                            error:
                              $v.testConfigData.config.quesPerScreen.$error,
                          }"
                          :disabled="configType == 'view'"
                        ></b-form-input>
                        <div
                          style="position: absolute; top: 67px; left: 8px"
                          v-if="
                            $v.testConfigData.config.quesPerScreen.$dirty &&
                            !$v.testConfigData.config.quesPerScreen.required
                          "
                          class="error-txt-tc"
                        >
                          Required
                        </div>
                        <div
                          style="position: absolute; top: 67px; left: 8px"
                          v-if="
                            !$v.testConfigData.config.quesPerScreen.between &&
                            $v.testConfigData.config.quesPerScreen.numeric
                          "
                          class="error-txt-tc"
                        >
                          Should be between 1 to 10
                        </div>
                      </div>
                    </b-col>
                    <b-col>
                      <div class="tc-form-fields mt-3 relativeclass">
                        <label class="tc-form-labels"
                          >Specify Negative Marks
                          <span class="asterik">*</span></label
                        >
                        <b-form-input
                          id="input-1"
                          type="text"
                          class="mt-1"
                          placeholder="Enter Here"
                          v-model.trim="
                            $v.testConfigData.config.negativeMarkValue.$model
                          "
                          @keypress="validateInput($event)"
                          :class="{
                            error:
                              $v.testConfigData.config.negativeMarkValue.$error,
                          }"
                          :disabled="configType == 'view'"
                        ></b-form-input>
                        <div
                          style="position: absolute; top: 67px; left: 8px"
                          v-if="
                            $v.testConfigData.config.negativeMarkValue.$dirty &&
                            !$v.testConfigData.config.negativeMarkValue.required
                          "
                          class="error-txt-tc"
                        >
                          Required
                        </div>
                        <div
                          style="position: absolute; top: 67px; left: 8px"
                          v-if="
                            !$v.testConfigData.config.negativeMarkValue
                              .numeric &&
                            $v.testConfigData.config.negativeMarkValue.required
                          "
                          class="error-txt-tc"
                        >
                          Not valid number
                        </div>
                        <div
                          style="position: absolute; top: 67px; left: 8px"
                          v-if="
                            !$v.testConfigData.config.negativeMarkValue
                              .between &&
                            $v.testConfigData.config.negativeMarkValue.numeric
                          "
                          class="error-txt-tc"
                        >
                          Should be between 0 to 30
                        </div>
                      </div>
                    </b-col>
                  </b-row>

                  <b-row class="mt-2">
                    <b-col cols="4">
                      <div class="tc-form-fields mt-3 position-relative">
                        <label class="tc-form-labels"
                          >Maximum Number of Attempts
                          <span class="asterik">*</span></label
                        >
                        <b-form-input
                          :id="timeDiffAttempts ? 'attempt' : ''"
                          type="text"
                          placeholder="Enter Here"
                          v-model.trim="
                            $v.testConfigData.config.maxnoattempts.$model
                          "
                          :class="{
                            error:
                              $v.testConfigData.config.maxnoattempts.$error,
                          }"
                          @keypress="validateInput($event)"
                          :disabled="configType == 'view' || timeDiffAttempts"
                          @keyup="checkMaxAttempts"
                        ></b-form-input>
                        <b-popover
                          target="attempt"
                          triggers="hover"
                          placement="bottom"
                          customClass="attempt-warning-box"
                        >
                          <img
                            src="../../../assets/atempt-warning.svg"
                            alt=""
                          />
                          As the start and end time & date duration is only
                          applicable to a single attempt, you cannot select more
                          than one maximum number of attempts.
                        </b-popover>
                        <div
                          style="position: absolute; top: 63px; left: 9px"
                          v-if="
                            $v.testConfigData.config.maxnoattempts.$dirty &&
                            !$v.testConfigData.config.maxnoattempts.required
                          "
                          class="error-txt-tc"
                        >
                          Required
                        </div>
                        <div
                          style="position: absolute; top: 63px; left: 9px"
                          v-if="
                            !$v.testConfigData.config.maxnoattempts.numeric &&
                            $v.testConfigData.config.maxnoattempts.required
                          "
                          class="error-txt-tc"
                        >
                          Not valid number
                        </div>
                        <div
                          style="position: absolute; top: 63px; left: 9px"
                          v-if="
                            !$v.testConfigData.config.maxnoattempts.between &&
                            $v.testConfigData.config.maxnoattempts.numeric
                          "
                          class="error-txt-tc"
                        >
                          Should be between 1 to 10
                        </div>
                      </div>
                    </b-col>
                    <b-col cols="4">
                      <div class="tc-form-fields mt-3 relativeclass">
                        <label class="tc-form-labels"
                          >Buffer Time (minutes)
                          <span class="asterik">*</span></label
                        >
                        <b-form-input
                          id="input-1"
                          type="text"
                          placeholder="Enter Here"
                          v-model.trim="
                            $v.testConfigData.config.buffertime.$model
                          "
                          @keypress="validateInput($event)"
                          :class="{
                            error: $v.testConfigData.config.buffertime.$error,
                          }"
                          :disabled="configType == 'view'"
                        ></b-form-input>
                        <div
                          style="position: absolute; top: 63px; left: 9px"
                          v-if="
                            $v.testConfigData.config.buffertime.$dirty &&
                            !$v.testConfigData.config.buffertime.required
                          "
                          class="error-txt-tc"
                        >
                          Required
                        </div>
                        <div
                          style="position: absolute; top: 63px; left: 9px"
                          v-if="
                            !$v.testConfigData.config.buffertime.numeric &&
                            $v.testConfigData.config.buffertime.required
                          "
                          class="error-txt-tc"
                        >
                          Invalid number
                        </div>
                        <div
                          style="position: absolute; top: 63px; left: 9px"
                          v-if="
                            $v.testConfigData.config.buffertime.numeric &&
                            !$v.testConfigData.config.buffertime.between &&
                            $v.testConfigData.config.buffertime.required
                          "
                          class="error-txt-tc"
                        >
                          Should be between 0 to 60
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2">
                    <b-col cols="8">
                      <label class="tc-form-labels mt-3" style="left: 0">
                        Time Between Attempts
                        <span class="asterik">*</span></label
                      >
                    </b-col>
                    <b-col cols="4">
                      <label
                        v-if="testConfigData.config.maxnoattempts > 1"
                        class="tc-form-labels mt-3"
                        style="left: 0"
                      >
                        Priority Attempt <span class="asterik">*</span></label
                      >
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="4">
                      <div class="position-relative mt-2">
                        <div
                          class="time-div-tc d-flex justify-content-between"
                          @click="
                            testConfigData.config.maxnoattempts < 2 ||
                            !enableEditing
                              ? ''
                              : setTimeAttempts()
                          "
                          :class="{
                            error: $v.testConfigData.config.timebnsel.$error,
                            'global-disabledField':
                              testConfigData.config.maxnoattempts < 2 ||
                              configType == 'view',
                          }"
                          :style="
                            testConfigData.config.maxnoattempts > 1 &&
                            configType != 'view'
                              ? 'background: none; '
                              : 'background: rgba(140, 140, 140, 0.15);color:#667085'
                          "
                        >
                          <span>{{
                            testConfigData.config.timebnsel == "hrs"
                              ? "Hours"
                              : testConfigData.config.timebnsel == "mins"
                              ? "Minutes"
                              : testConfigData.config.timebnsel == "days"
                              ? "Days"
                              : "Select"
                          }}</span>

                          <div>
                            <img
                              v-if="!timeattempts"
                              src="../../../assets/img/createjd/downarrow.svg"
                              :class="{
                                pointer:
                                  testConfigData.config.maxnoattempts > 1,
                              }"
                              alt=""
                            />
                            <img
                              v-else
                              src="../../../assets/img/createjd/uparrow.svg"
                              :class="{
                                pointer:
                                  testConfigData.config.maxnoattempts > 1,
                              }"
                              alt=""
                            />
                          </div>
                        </div>
                        <div
                          ref="timelist"
                          class="
                            time-div-tc-dpd
                            acs-landingpage-dropdown
                            pointer
                            mt-1
                          "
                          v-if="timeattempts"
                        >
                          <b-form-group>
                            <div
                              class="w-100 time-div-tc-dpd d-flex flex-column"
                              v-if="!editJob"
                            >
                              <div
                                class="pointer p-2"
                                v-for="option in filteredTimeOptions"
                                :key="option.value"
                                :value="option.value"
                                @change="closeTime"
                              >
                                {{ option.text }}
                              </div>
                            </div>

                            <b-form-radio-group
                              @change="closeTime"
                              class="w-100"
                              id="btn-radios-3"
                              v-model="
                                $v.testConfigData.config.timebnsel.$model
                              "
                              :options="filteredTimeOptions"
                              :disabled="isViewConfig"
                              name="radio-btn-stacked"
                              buttons
                              stacked
                              v-if="editJob"
                            ></b-form-radio-group>
                          </b-form-group>
                        </div>
                        <div
                          style="position: absolute; top: 40px; left: 7px"
                          v-if="
                            $v.testConfigData.config.timebnsel.$dirty &&
                            !$v.testConfigData.config.timebnsel.required
                          "
                          class="error-txt-tc"
                        >
                          Required
                        </div>
                      </div>
                    </b-col>
                    <b-col cols="4">
                      <div class="tc-form-fields mt-2 relativeclass pb-2">
                        <b-form-input
                          id="input-1"
                          type="text"
                          :placeholder="`${
                            testConfigData.config.timebnsel == 'hrs'
                              ? 'Enter in Hours'
                              : testConfigData.config.timebnsel == 'mins'
                              ? 'Enter in Minutes'
                              : testConfigData.config.timebnsel == 'days'
                              ? 'Enter in Days'
                              : 'Enter Time'
                          }`"
                          v-model="$v.testConfigData.config.timebnvalue.$model"
                          @keypress="validateInput($event)"
                          :class="{
                            error:
                              ($v.testConfigData.config.timebnvalue.$error ||
                                testConfigData.config.timebnvalue == '0' ||
                                !validateTime ||
                                !validTimeBetAttempts) &&
                              $v.testConfigData.config.timebnvalue.$dirty,
                            inputField:
                              configType !== 'view' &&
                              testConfigData.config.maxnoattempts > 1 &&
                              testConfigData.config.timebnsel !== '',
                            testconfiginputField:
                              configType === 'view' ||
                              testConfigData.config.maxnoattempts < 2 ||
                              testConfigData.config.timebnsel === '',
                          }"
                          :disabled="
                            configType == 'view' ||
                            testConfigData.config.maxnoattempts < 2 ||
                            testConfigData.config.timebnsel === ''
                          "
                        ></b-form-input>
                        <div
                          style="position: absolute; top: 40px; left: 9px"
                          v-if="
                            $v.testConfigData.config.timebnvalue.$dirty &&
                            !$v.testConfigData.config.timebnvalue.required
                          "
                          class="error-txt-tc"
                        >
                          Required
                        </div>
                        <div
                          style="position: absolute; top: 40px; left: 9px"
                          v-if="
                            testConfigData.config.timebnsel === 'hrs' &&
                            ((!validateTime &&
                              $v.testConfigData.config.timebnvalue.required) ||
                              testConfigData.config.timebnvalue == '0')
                          "
                          class="error-txt-tc"
                        >
                          Should be between 1 to 24
                        </div>
                        <div
                          style="position: absolute; top: 40px; left: 9px"
                          v-if="
                            testConfigData.config.timebnsel === 'mins' &&
                            ((!validateTime &&
                              $v.testConfigData.config.timebnvalue.required) ||
                              testConfigData.config.timebnvalue == '0')
                          "
                          class="error-txt-tc"
                        >
                          Should be between 0.5 to 60
                        </div>

                        <div
                          style="position: absolute; top: 40px; left: 9px"
                          v-if="
                            testConfigData.config.timebnsel === 'days' &&
                            ((!validateTime &&
                              $v.testConfigData.config.timebnvalue.required) ||
                              testConfigData.config.timebnvalue == '0')
                          "
                          class="error-txt-tc"
                        >
                          Should be between 1 to 365
                        </div>
                        <div
                          style="position: absolute; top: 40px; left: 9px"
                          v-else-if="
                            !validTimeBetAttempts &&
                            $v.testConfigData.config.timebnsel.$dirty
                          "
                          class="error-txt-tc"
                        >
                          Time between attempts can't exceed start-end time
                          difference.
                        </div>
                        <div
                          style="position: absolute; top: 40px; left: 9px"
                          v-if="
                            (testConfigData.config.timebnsel === 'mins' ||
                              testConfigData.config.timebnsel === 'days' ||
                              testConfigData.config.timebnsel === 'hrs') &&
                            !$v.testConfigData.config.timebnvalue.numeric &&
                            $v.testConfigData.config.timebnvalue.required
                          "
                          class="error-txt-tc"
                        >
                          Invalid number
                        </div>
                      </div>
                    </b-col>
                    <b-col
                      class="mt-2"
                      v-if="testConfigData.config.maxnoattempts > 1"
                    >
                      <div
                        class="allocateradios d-flex align-items-center mt-2"
                      >
                        <b-form-radio-group
                          class="priority-labels"
                          :options="priorityoptions"
                          v-model="testConfigData.config.priority"
                          :disabled="configType == 'view'"
                          value-field="item"
                          text-field="name"
                          size="sm"
                        ></b-form-radio-group>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col cols="4">
                      <div class="pff-checkbox">
                        <b-form-checkbox
                          size="md"
                          class="mt-3"
                          name="checkbox-1"
                          v-model="testConfigData.config.displayReqFirst"
                          :disabled="configType == 'view'"
                        >
                          Display Mandatory Questions First
                        </b-form-checkbox>
                      </div>
                    </b-col>
                    <b-col cols="4">
                      <div class="pff-checkbox">
                        <b-form-checkbox
                          size="md"
                          class="mt-3"
                          name="checkbox-1"
                          v-model="testConfigData.config.dispMarks"
                          :disabled="configType == 'view'"
                        >
                          Display Marks for every Questions
                        </b-form-checkbox>
                      </div>
                    </b-col>
                    <b-col cols="4">
                      <div class="pff-checkbox">
                        <b-form-checkbox
                          size="md"
                          class="mt-3"
                          name="checkbox-1"
                          v-model="testConfigData.config.shuffle"
                          :disabled="configType == 'view'"
                        >
                          Randomly Shuffle Questions
                        </b-form-checkbox>
                      </div>
                    </b-col>
                  </b-row>

                  <b-row class="mt-3">
                    <b-col cols="4">
                      <div class="pff-checkbox">
                        <b-form-checkbox
                          size="md"
                          class="mt-3"
                          name="checkbox-1"
                          v-model="testConfigData.config.dispReqStatus"
                          :disabled="configType == 'view'"
                        >
                          Display Mandatory Questions Icon
                        </b-form-checkbox>
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <div class="d-flex tc-btnsDiv justify-content-between p-3">
                  <div class="cancelpan-btn">
                    <b-button @click="previoustab()" class="h-32 w-87 ml-2"
                      >Previous</b-button
                    >
                  </div>
                  <div class="d-flex">
                    <div class="add-btn-tc">
                      <b-button
                        class="h-32 w-87 ml-2"
                        v-if="configType == 'view'"
                        @click="enableEditing"
                      >
                        <span class="add-btn-tc-txt"> Edit</span>
                      </b-button>
                    </div>
                    <div class="cancelpan-btn" v-if="configType != 'view'">
                      <b-button @click="closeModal" class="h-32 w-87 ml-2"
                        >Cancel</b-button
                      >
                    </div>
                    <div class="add-btn-tc" v-if="configType != 'view'">
                      <b-button
                        @click="questionbehaviour(true)"
                        class="h-32 w-87 ml-4"
                        ><span class="add-btn-tc-txt">Next</span></b-button
                      >
                    </div>
                    <div class="cancelpan-btn" v-if="configType == 'view'">
                      <b-button
                        @click="questionbehaviour(true)"
                        class="h-32 w-87 ml-4"
                        ><span class="">Next</span></b-button
                      >
                    </div>
                  </div>
                </div>
              </b-tab>

              <b-tab>
                <template #title>
                  System Setup
                  <img
                    style="position: absolute; top: 15px"
                    v-b-popover.hover.top.v-danger="{
                      content: 'Please fill all the details',
                    }"
                    v-if="
                      $v.testConfigData.config.screenCapture.$error ||
                      $v.testConfigData.config.communicationTestAttempts
                        .$error ||
                      (testConfigData.config.enableProctoring == true &&
                        testConfigData.config.enableCamera == false)
                    "
                    src="../../../assets/img/config-modules/big-warning-red.svg"
                    alt=""
                  />
                  <div v-if="tabIndex == 2" class="tc-tab-sel"></div>
                </template>
                <div class="pr-2 configcontent-tabs-content px-5">
                  <b-row>
                    <b-col>
                      <div>
                        <b-row>
                          <b-col cols="4">
                            <div class="mt-3 relativeclass pff-checkbox">
                              <b-form-checkbox
                                class="mt-3"
                                size=" md"
                                :disabled="configType == 'view'"
                                v-model="
                                  testConfigData.config.communicationTest
                                "
                                name="checkbox-1"
                                @input="checkCommunicationTestAttempts"
                              >
                                Communication Test
                              </b-form-checkbox>
                            </div>
                          </b-col>
                          <b-col cols="4">
                            <div class="mt-3 relativeclass pff-checkbox">
                              <b-form-checkbox
                                class="mt-3"
                                size=" md"
                                v-model="testConfigData.config.enableProctoring"
                                name="checkbox-1"
                                :disabled="configType == 'view'"
                                @change="enableVid"
                              >
                                Enable Proctoring
                              </b-form-checkbox>
                            </div>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="4">
                            <div class="tc-form-fields mt-3 relativeclass">
                              <label class="tc-form-labels"
                                >Communication Test Attempts<span
                                  class="asterik"
                                  >*</span
                                ></label
                              >
                              <b-form-input
                                class=""
                                id="input-1"
                                placeholder="Enter Here"
                                type="text"
                                v-model.trim="
                                  $v.testConfigData.config
                                    .communicationTestAttempts.$model
                                "
                                @keypress="validateInput($event)"
                                :disabled="
                                  !testConfigData.config.communicationTest ||
                                  configType == 'view'
                                "
                                :class="{
                                  error:
                                    $v.testConfigData.config
                                      .communicationTestAttempts.$error,
                                }"
                              ></b-form-input>
                              <div
                                style="position: absolute; top: 62px; left: 8px"
                                v-if="
                                  $v.testConfigData.config
                                    .communicationTestAttempts.$dirty &&
                                  !$v.testConfigData.config
                                    .communicationTestAttempts.required
                                "
                                class="error-txt-tc"
                              >
                                Required
                              </div>
                              <div
                                style="position: absolute; top: 62px; left: 8px"
                                v-else-if="
                                  (!$v.testConfigData.config
                                    .communicationTestAttempts.between &&
                                    $v.testConfigData.config
                                      .communicationTestAttempts.numeric) ||
                                  isNegativeCommunicationTestAttempts
                                "
                                class="error-txt-tc"
                              >
                                Should be between 1 to 5
                              </div>
                              <div
                                style="position: absolute; top: 62px; left: 8px"
                                v-else-if="
                                  !$v.testConfigData.config
                                    .communicationTestAttempts.numeric &&
                                  $v.testConfigData.config
                                    .communicationTestAttempts.required &&
                                  !isNegativeCommunicationTestAttempts
                                "
                                class="error-txt-tc"
                              >
                                Not valid number
                              </div>
                            </div>
                          </b-col>
                          <b-col cols="4">
                            <div class="tc-form-fields mt-3 relativeclass">
                              <label class="w-303 tc-form-labels"
                                >Set Image Capture Timing-Slot (Seconds)
                                <span class="asterik">*</span></label
                              >
                              <b-form-input
                                class=""
                                id="input-1"
                                :disabled="
                                  testConfigData.config.enableProctoring ==
                                    false || configType == 'view'
                                "
                                placeholder="Enter Here"
                                type="text"
                                v-model.trim="
                                  $v.testConfigData.config.screenCapture.$model
                                "
                                @keypress="validateInput($event)"
                                :class="{
                                  error:
                                    $v.testConfigData.config.screenCapture
                                      .$error,
                                }"
                              ></b-form-input>
                              <div
                                style="position: absolute; top: 62px; left: 8px"
                                v-if="
                                  $v.testConfigData.config.screenCapture
                                    .$dirty &&
                                  !$v.testConfigData.config.screenCapture
                                    .required
                                "
                                class="error-txt-tc"
                              >
                                Required
                              </div>
                              <div
                                style="position: absolute; top: 62px; left: 8px"
                                v-if="
                                  !$v.testConfigData.config.screenCapture
                                    .between &&
                                  $v.testConfigData.config.screenCapture
                                    .required
                                "
                                class="error-txt-tc"
                              >
                                Should be between (1, 15)
                              </div>
                              <div
                                style="position: absolute; top: 62px; left: 8px"
                                v-if="
                                  !$v.testConfigData.config.screenCapture
                                    .numeric &&
                                  $v.testConfigData.config.screenCapture
                                    .required
                                "
                                class="error-txt-tc"
                              >
                                Invalid number (decimal not allowed)
                              </div>
                            </div>
                          </b-col>
                          <b-col class="mt-3">
                            <div class="mt-3 relativeclass d-flex pff-checkbox">
                              <b-form-checkbox
                                class="mt-3"
                                size=" md"
                                name="checkbox-1"
                                :disabled="configType == 'view'"
                                v-model="testConfigData.config.enableCamera"
                                @input="
                                  selectDosAndDonts(
                                    testConfigData.config.enableCamera,
                                    'enableCamera'
                                  )
                                "
                              >
                                Enable Video
                              </b-form-checkbox>
                              <img
                                v-if="testConfigData.config.enableCamera"
                                src="../../../assets/img/config-modules/popup-icon-blue.svg"
                                alt=""
                                class="mt-3 ml-1"
                                v-b-popover.hover.top="{
                                  content:
                                    'Enabled video since proctoring is enabled',
                                }"
                              />
                            </div>
                          </b-col>
                        </b-row>

                        <hr class="mt-4 mb-2" />
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <div>
                        <b-row>
                          <b-col>
                            <div class="mt-3 relativeclass pff-checkbox">
                              <b-form-checkbox
                                class="mt-3"
                                size=" md"
                                v-model="
                                  testConfigData.config.allowImageAndIdCapture
                                "
                                :disabled="configType == 'view'"
                                name="checkbox-1"
                                @change="
                                  selectDosAndDonts(
                                    testConfigData.config
                                      .allowImageAndIdCapture,
                                    'allowImageAndIdCapture'
                                  )
                                "
                              >
                                Allow Image And ID Capture
                              </b-form-checkbox>
                            </div>
                          </b-col>
                          <b-col>
                            <div class="mt-3 relativeclass pff-checkbox">
                              <b-form-checkbox
                                class="mt-3"
                                size=" md"
                                name="checkbox-1"
                                :disabled="configType == 'view'"
                                v-model="testConfigData.config.typingTest"
                              >
                                Typing Test
                              </b-form-checkbox>
                            </div>
                          </b-col>
                          <b-col>
                            <div class="mt-3 relativeclass pff-checkbox">
                              <b-form-checkbox
                                class="mt-3"
                                size=" md"
                                name="checkbox-1"
                                :disabled="configType == 'view'"
                                v-model="testConfigData.config.instantemail"
                                @change="
                                  selectDosAndDonts(
                                    testConfigData.config.instantemail,
                                    'instantemail'
                                  )
                                "
                                >Instant Test Result
                              </b-form-checkbox>
                            </div>
                          </b-col>
                        </b-row>

                        <b-row>
                          <b-col>
                            <div class="Div mt-3 relativeclass pff-checkbox">
                              <b-form-checkbox
                                class="mt-3"
                                size=" md"
                                v-model="testConfigData.config.allowAgent"
                                name="checkbox-1"
                                :disabled="configType == 'view'"
                                @change="
                                  selectDosAndDonts(
                                    testConfigData.config.allowAgent,
                                    'allowAgent'
                                  )
                                "
                                >Allow Agent
                              </b-form-checkbox>
                            </div>
                          </b-col>
                          <b-col>
                            <div class="mt-3 relativeclass pff-checkbox">
                              <b-form-checkbox
                                class="mt-3"
                                size=" md"
                                name="checkbox-1"
                                :disabled="configType == 'view'"
                                v-model="
                                  testConfigData.config.allowCandidateRemarks
                                "
                              >
                                Allow Candidate Feedback
                              </b-form-checkbox>
                            </div>
                          </b-col>
                          <b-col>
                            <div class="mt-3 relativeclass pff-checkbox">
                              <b-form-checkbox
                                class="mt-3"
                                v-model="
                                  testConfigData.config.enableScreenShare
                                "
                                size=" md"
                                name="checkbox-1"
                                :disabled="configType == 'view'"
                                @change="
                                  selectDosAndDonts(
                                    testConfigData.config.enableScreenShare,
                                    'enableScreenShare'
                                  )
                                "
                              >
                                Enable Screen Share
                              </b-form-checkbox>
                            </div>
                          </b-col>
                        </b-row>

                        <b-row>
                          <b-col>
                            <div class="mt-3 relativeclass pff-checkbox">
                              <b-form-checkbox
                                class="mt-3"
                                size=" md"
                                :disabled="configType == 'view'"
                                v-model="
                                  testConfigData.config.includeTimeNotifics
                                "
                                name="checkbox-1"
                              >
                                Include Time Sensitivity Notifications
                              </b-form-checkbox>
                            </div>
                          </b-col>
                          <b-col>
                            <div class="mt-3 relativeclass pff-checkbox">
                              <b-form-checkbox
                                class="mt-3"
                                v-model="testConfigData.config.allowExtension"
                                size=" md"
                                :disabled="configType == 'view'"
                                name="checkbox-1"
                                @change="
                                  selectDosAndDonts(
                                    testConfigData.config.allowExtension,
                                    'allowExtension'
                                  )
                                "
                              >
                                Allow Extension
                              </b-form-checkbox>
                            </div>
                          </b-col>
                          <b-col>
                            <div class="mt-3 relativeclass pff-checkbox">
                              <b-form-checkbox
                                class="mt-3"
                                size=" md"
                                name="checkbox-1"
                                v-model="testConfigData.config.internetCheck"
                                :disabled="configType == 'view'"
                              >
                                <div class="">Enable Internet Check</div>
                              </b-form-checkbox>
                            </div>
                          </b-col>
                        </b-row>
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <div class="d-flex tc-btnsDiv justify-content-between p-3">
                  <div class="cancelpan-btn">
                    <b-button @click="previoustab()" class="h-32 w-87 ml-2"
                      >Previous</b-button
                    >
                  </div>
                  <div class="d-flex">
                    <div class="add-btn-tc">
                      <b-button
                        class="h-32 w-87 ml-2"
                        v-if="configType == 'view'"
                        @click="enableEditing"
                      >
                        <span class="add-btn-tc-txt"> Edit</span>
                      </b-button>
                    </div>
                    <div class="cancelpan-btn" v-if="configType != 'view'">
                      <b-button @click="closeModal" class="h-32 w-87 ml-2"
                        >Cancel</b-button
                      >
                    </div>
                    <div class="add-btn-tc" v-if="configType != 'view'">
                      <b-button
                        @click="systemSetup(true)"
                        class="h-32 w-87 ml-4"
                        ><span class="add-btn-tc-txt">Next</span></b-button
                      >
                    </div>
                    <div class="cancelpan-btn" v-if="configType == 'view'">
                      <b-button
                        @click="systemSetup(true)"
                        class="h-32 w-87 ml-4"
                        ><span class="">Next</span></b-button
                      >
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab>
                <template #title>
                  Do’s and Dont’s
                  <img
                    style="position: absolute; top: 15px"
                    v-b-popover.hover.top.v-danger="{
                      content: 'Please fill all the details',
                    }"
                    v-if="$v.testConfigData.config.dosAndDonts.$error"
                    src="../../../assets/img/config-modules/big-warning-red.svg"
                    alt=""
                  />
                  <div v-if="tabIndex == 3" class="tc-tab-sel"></div>
                </template>
                <div class="pr-2 configcontent-tabs-content px-5">
                  <draggable
                    tag="div"
                    group="trueexpdata"
                    :list="testConfigData.config.dosAndDonts"
                    class="pointer"
                  >
                    <div class="dos-donts-head-tc">Do's & Dont’s</div>
                    <div class="dos-donts-head-tc">
                      (Min 1 required)<span class="asterik">*</span>
                    </div>

                    <div
                      v-for="(i, index) in testConfigData.config.dosAndDonts"
                      :key="index"
                      class="mt-3"
                    >
                      <div class="d-flex">
                        <div
                          class="d-flex dos-donts-fields w-96 position-relative"
                        >
                          <div class="mr-2 mt-2">
                            <span class="dos-donts-num">{{ index + 1 }}. </span>
                          </div>
                          <b-form-input
                            autofocus
                            class="pointer"
                            placeholder="Enter"
                            v-model.trim="
                              $v.testConfigData.config.dosAndDonts.$each[index]
                                .value.$model
                            "
                            :class="{
                              error:
                                $v.testConfigData.config.dosAndDonts.$each[
                                  index
                                ].value.$error,
                            }"
                            type="text"
                            @keyup.enter="addOptions"
                            :disabled="configType == 'view'"
                          ></b-form-input>
                        </div>
                        <div
                          class="jd-validicon-tc"
                          v-if="
                            $v.testConfigData.config.dosAndDonts.$each[index]
                              .value.$dirty &&
                            !$v.testConfigData.config.dosAndDonts.$each[index]
                              .value.required
                          "
                        >
                          <span class="error-txt-tc">Required</span>
                        </div>
                        <div
                          class="jd-validicon-tc"
                          v-if="
                            !$v.testConfigData.config.dosAndDonts.$each[index]
                              .value.maxLength &&
                            $v.testConfigData.config.dosAndDonts.$each[index]
                              .value.required
                          "
                        >
                          <span class="error-txt-tc"
                            >Should not exceed 512 characters</span
                          >
                        </div>
                        <div
                          v-if="
                            configType != 'view' &&
                            index ==
                              testConfigData.config.dosAndDonts.length - 1
                          "
                          class="tc-dodont-del-pos m-1 px-1"
                        >
                          <img
                            v-if="
                              !$v.testConfigData.config.dosAndDonts.$each[index]
                                .value.$dirty ||
                              !$v.testConfigData.config.dosAndDonts.$each[index]
                                .value.required
                            "
                            src="../../../assets/img/config-modules/disable-DandDs.svg"
                            alt=""
                          />
                          <img
                            v-else
                            @click="addOptions"
                            src="../../../assets/img/config-modules/gray-add-btn.svg"
                            alt=""
                          />
                        </div>
                        <div
                          class="tc-dodont-del-pos m-1 px-1"
                          v-else-if="
                            testConfigData.config.dosAndDonts.length > 1 &&
                            configType != 'view'
                          "
                        >
                          <img
                            @click="deleteOption(index)"
                            v-if="configType != 'view'"
                            src="../../../assets/img/config-modules/blue-delete.svg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </draggable>
                  <div v-if="errorstatus" class="text-center">
                    <span class="asterik"
                      >*please fill mandatory fields in all tabs</span
                    >
                  </div>
                </div>
                <div class="d-flex tc-btnsDiv justify-content-between p-3">
                  <div class="cancelpan-btn">
                    <b-button @click="previoustab()" class="h-32 w-87 ml-2"
                      >Previous</b-button
                    >
                  </div>
                  <div class="d-flex">
                    <div class="add-btn-tc">
                      <b-button
                        class="h-32 w-87 ml-2"
                        v-if="configType == 'view'"
                        @click="enableEditing"
                        ><span class="add-btn-tc-txt"> Edit</span>
                      </b-button>
                    </div>
                    <div class="add-btn-tc">
                      <b-button
                        @click="checkConfigValidations"
                        class="h-32 w-150 ml-4"
                        v-if="configType != 'view'"
                        ><span class="add-btn-tc-txt">{{
                          configType === "add"
                            ? "Save & Proceed"
                            : "Update & Proceed"
                        }}</span></b-button
                      >
                    </div>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
      <ConfirmModal
        v-if="cautionModal"
        :confirmModal="cautionModal"
        @handle-submit="confirm()"
        @save-draft="addConfig()"
        @closeModal="cautionModal = false"
        :btnName="'Create New'"
        :button="'Confirm'"
        :header="'Caution!'"
        :imageSrc="require('@/assets/img/feedbackform/confirmIcon.svg')"
        :msg="'Are you sure you want to edit? <br/>This config is tagged to more than one group. Do you want to crete a new config or confirm the action?'"
      />
    </b-overlay>
  </b-modal>
</template>
<script>
import QuillEditor from "../../../components/fixedcomponents/quillEditor.vue";
import { DateTime as LuxonDateTime } from "luxon";
import JDConstants from "../constants.js";
import draggable from "vuedraggable";
import { getdosanddonts } from "../../workbench/asynchronous.js";
import Vue from "vue";
import {
  addConfig,
  dosanddontslist,
  editConfig,
} from "../../../utils/apiFunctions.js";
import {
  required,
  requiredIf,
  numeric,
  between,
  maxLength,
  helpers,
} from "vuelidate/lib/validators";
import errorModal from "../../../components/mixin/toast";
import successModal from "../../../components/mixin/toast";
import SelectDropdown from "../../../components/fixedcomponents/Select.vue";
import { convertTime } from "../helpers";
import ConfirmModal from "@/views/InterviewProcess/ConfirmModal.vue";

const eventBus = new Vue();
Vue.prototype.$eventBus = eventBus;
export default {
  name: "TestConfig",
  components: {
    draggable,
    QuillEditor,
    SelectDropdown,
    ConfirmModal,
  },
  props: {
    showModal: Boolean,
    configType: String,
    configData: Object,
    isExpireEdit: Boolean,
    checkConfig: Function,
    context: Object,
  },
  mixins: [successModal, errorModal],
  data() {
    return {
      dateValueFormat: "YYYY-MM-DDTHH:mm:ss.SSS[Z]",
      dateDisplayFormat: "DD-MM-YYYY HH-mm",
      showOverlay: true,
      testoptError: false,
      cautionModal: false,
      dosAndDontsList: [],
      check: true,
      defaultConfigValues: {
        configName: "",
        config: {
          timebnsel: "",
          timebnvalue: "",
          testOrg: "",
          testDesc: "",
          testInst: "",
          dispDuration: true,
          dispCount: true,
          allowCandidateRemarks: false,
          quesPerScreen: "",
          shuffle: false,
          dispReqStatus: false,
          displayReqFirst: false,
          dispMarks: false,
          test: "",
          allowAgent: false,
          allowImageAndIdCapture: false,
          allowExtension: false,
          negativeMarkValue: null,
          openTestdt: null,
          closeTestdt: null,
          enableProctoring: false,
          enableScreenShare: false,
          passingPercentage: "",
          testDuration: "30",
          communicationTestDuration: 45,
          includeTimeNotifics: false,
          enableCamera: false,
          includeEndTest: true,
          instantemail: false,
          typingTest: false,
          typingDuration: 60,
          communicationTest: false,
          ommunicationTestDuration: 45,
          maxnoattempts: 1,
          buffertime: null,
          timebetweenattempts: null,
          communicationTestAttempts: null,
          screenCapture: null,
          priority: "first",
          dosAndDonts: [
            {
              value: "",
            },
          ],
        },
      },
      testConfigData: {
        configName: "",
        config: {
          timebnsel: "",
          timebnvalue: "",
          testOrg: "",
          testDesc: "",
          testInst: "",
          dispDuration: true,
          dispCount: true,
          allowCandidateRemarks: false,
          quesPerScreen: "",
          shuffle: false,
          dispReqStatus: false,
          displayReqFirst: false,
          dispMarks: false,
          test: "",
          allowAgent: false,
          allowImageAndIdCapture: false,
          allowExtension: false,
          negativeMarkValue: null,
          openTestdt: null,
          closeTestdt: null,
          enableProctoring: false,
          enableScreenShare: false,
          passingPercentage: "",
          testDuration: "30",
          communicationTestDuration: 45,
          includeTimeNotifics: false,
          enableCamera: false,
          includeEndTest: true,
          instantemail: false,
          typingTest: false,
          typingDuration: 60,
          communicationTest: false,
          ommunicationTestDuration: 45,
          maxnoattempts: 1,
          buffertime: null,
          timebetweenattempts: null,
          communicationTestAttempts: null,
          screenCapture: 0,
          priority: "first",
          dosAndDonts: [
            {
              value: "",
            },
          ],
        },
      },
      selectOptions: {
        text: "",
        value: "",
      },
      tabIndex: 0,
      testinstruction: "not_accepted",
      addques1: false,
      addques2: false,
      globalWorks: false,
      fieldsinvalid: false,
      fieldsinvalidosd: false,
      fieldsinvalidqb: false,
      fieldsinvalidss: false,
      editJob: true,
      testoptions: JDConstants.TESTOPTIONS,
      errorstatus: false,
      timeoptions: JDConstants.TIMEOPTIONS,
      priorityoptions: JDConstants.PRIORITYOPTIONS,
      timeattempts: false,
      dirtyCheckDescQuestion: false,
      dirtyCheckQuestion: false,
      startdatetime: LuxonDateTime.local().minus({ month: 0, days: 0 }).toISO(),
      editorConfig: {
        toolbar: [["Bold", "Italic", "-", "NumberedList", "BulletedList", "-"]],
      },
    };
  },
  computed: {
    isViewConfig() {
      return this.configType === "view";
    },
    validTimeBetAttempts() {
      if (
        this.testConfigData.config.openTestdt &&
        this.testConfigData.config.closeTestdt &&
        this.testConfigData.config.maxnoattempts > 1
      ) {
        const startDate = new Date(this.testConfigData.config.openTestdt);
        const endDate = new Date(this.testConfigData.config.closeTestdt);
        const timeDiffInMilliseconds = endDate.getTime() - startDate.getTime();
        let timeDiff;
        if (this.testConfigData.config.timebnsel === "hrs") {
          timeDiff = timeDiffInMilliseconds / (1000 * 60 * 60);
        } else if (this.testConfigData.config.timebnsel === "mins") {
          timeDiff = timeDiffInMilliseconds / (1000 * 60);
        } else if (this.testConfigData.config.timebnsel === "days") {
          timeDiff = timeDiffInMilliseconds / (1000 * 60 * 60 * 24);
        }
        return this.testConfigData.config.timebnvalue <= timeDiff;
      } else {
        return true;
      }
    },
    filteredTimeOptions() {
      const showHours = this.minutesDiffAttempts;
      const showDays = this.hoursDiffAttempts;
      return this.timeoptions.filter(
        (option) =>
          (option.value !== "hrs" || showHours) &&
          (option.value !== "days" || showDays)
      );
    },
    timeDiffAttempts() {
      if (
        this.testConfigData.config.openTestdt &&
        this.testConfigData.config.closeTestdt
      ) {
        const startDate = new Date(this.testConfigData.config.openTestdt);
        const endDate = new Date(this.testConfigData.config.closeTestdt);
        const timeDiff = endDate.getTime() - startDate.getTime();
        if (this.testConfigData.config.testDuration !== null) {
          return (
            this.testConfigData.config.testDuration * 2 >
            Math.floor(timeDiff / (1000 * 60))
          );
        }
        return false;
      }
      return null;
    },

    timeDiffMinutes() {
      if (
        this.testConfigData.config.openTestdt &&
        this.testConfigData.config.closeTestdt
      ) {
        const startDate = new Date(this.testConfigData.config.openTestdt);
        const endDate = new Date(this.testConfigData.config.closeTestdt);
        const timeDiff = endDate.getTime() - startDate.getTime();

        if (this.testConfigData.config.testDuration !== null) {
          return (
            this.testConfigData.config.testDuration >
            Math.floor(timeDiff / (1000 * 60))
          );
        }
        return false;
      }
      return null;
    },

    hoursDiffAttempts() {
      if (
        this.testConfigData.config.openTestdt &&
        this.testConfigData.config.closeTestdt
      ) {
        const startDate = new Date(this.testConfigData.config.openTestdt);
        const endDate = new Date(this.testConfigData.config.closeTestdt);
        const timeDiff = endDate.getTime() - startDate.getTime();

        if (this.testConfigData.config.testDuration !== null) {
          const hoursDiff = timeDiff / (1000 * 60 * 60);
          return hoursDiff > 24;
        }
        return false;
      }

      return null;
    },
    minutesDiffAttempts() {
      if (
        this.testConfigData.config.openTestdt &&
        this.testConfigData.config.closeTestdt
      ) {
        const startDate = new Date(this.testConfigData.config.openTestdt);
        const endDate = new Date(this.testConfigData.config.closeTestdt);
        const timeDiffInMilliseconds = endDate.getTime() - startDate.getTime();
        const timeDiffInHours = timeDiffInMilliseconds / (1000 * 60 * 60);

        if (this.testConfigData.config.testDuration !== null) {
          return timeDiffInHours > 1;
        }
        return false;
      }

      return null;
    },
    minDate() {
      return this.testConfigData.config.openTestdt;
    },
    isNegativeCommunicationTestAttempts() {
      const attempts = parseInt(
        this.testConfigData.config.communicationTestAttempts
      );
      return !isNaN(attempts) && attempts < 0;
    },
    validateTime() {
      if (this.testConfigData.config?.maxnoattempts > 1) {
        if (
          this.testConfigData.config?.timebnsel === "hrs" &&
          this.testConfigData.config?.timebnvalue > 0 &&
          this.testConfigData.config?.timebnvalue <= 24
        ) {
          return true;
        } else if (
          this.testConfigData.config?.timebnsel === "mins" &&
          this.testConfigData.config?.timebnvalue >= 0.5 &&
          this.testConfigData.config?.timebnvalue <= 60
        ) {
          return true;
        } else if (
          this.testConfigData.config?.timebnsel === "days" &&
          this.testConfigData.config?.timebnvalue >= 1 &&
          this.testConfigData.config?.timebnvalue <= 365
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
  },
  validations() {
    return {
      testConfigData: {
        configName: {
          required,
          maxLength: maxLength(128),
        },
        name: {
          required,
          maxLength: maxLength(128),
        },
        config: {
          testOrg: {
            required,
            maxLength: maxLength(128),
          },
          testDesc: {
            required,
            maxLength: maxLength(1024),
          },
          testInst: {
            required: requiredIf(function () {
              return this.testinstruction != "not_accepted";
            }),
            maxLength: maxLength(256),
          },
          test: {
            required,
          },
          quesPerScreen: {
            required,
            between: between(1, 10),
            numeric,
          },
          negativeMarkValue: {
            required,
            between: between(0, 30),
            numeric: helpers.regex("numeric", /^\d{1,3}\.?\d{0,2}$/),
          },
          passingPercentage: {
            required,
            between: between(1, 100),
            numeric: helpers.regex("numeric", /^\d{1,3}\.?\d{0,2}$/),
          },
          testDuration: {
            required,
            between: between(5, 360),
            alpha: helpers.regex("alpha", /^\d{0,3}(\.\d{0,2})?$/),
            numeric: helpers.regex("numeric", /^(-)?\d{0,3}(\.\d{0,2})?$/),
          },
          openTestdt: {
            required,
          },
          closeTestdt: {
            required,
            isDateValid: (value) => {
              const selectedDate = new Date(value);
              const currentDate = new Date();
              if (selectedDate == "Invalid Date") return true;
              else return selectedDate > currentDate;
            },
          },
          dosAndDonts: {
            $each: {
              value: {
                required,
                maxLength: maxLength(256),
              },
            },
          },
          paymentDetails: {
            cost: {
              required: requiredIf(function () {
                return this.testConfigData.config.payment;
              }),
            },
            about: {
              required: requiredIf(function () {
                return this.testConfigData.config.payment;
              }),
            },
            skillsGain: {
              required: requiredIf(function () {
                return this.testConfigData.config.payment;
              }),
            },
            toLearn: {
              required: requiredIf(function () {
                return this.testConfigData.config.payment;
              }),
            },
          },
          maxnoattempts: {
            required,
            numeric,
            between: between(1, 10),
          },
          buffertime: {
            required,
            numeric: helpers.regex("numeric", /^\d{1,3}\.?\d{0,2}$/),
            between: between(0, 60),
          },
          timebnvalue: {
            required: requiredIf(function () {
              return (
                this.testConfigData.config.maxnoattempts >= 2 &&
                this.testConfigData.config.timebnsel != ""
              );
            }),
            Validate: this.validateTime,
            numeric: helpers.regex("numeric", /^\d{1,3}\.?\d{0,2}$/),
          },
          timebnsel: {
            required: requiredIf(function () {
              return this.testConfigData.config.maxnoattempts >= 2;
            }),
          },
          screenCapture: {
            required: requiredIf(function () {
              return this.testConfigData.config.enableProctoring;
            }),
            numeric,
            between: between(1, 15),
          },
          communicationTestAttempts: {
            required: requiredIf(function () {
              return this.testConfigData.config.communicationTest;
            }),
            between: between(1, 5),
            numeric,
          },
        },
      },
    };
  },
  watch: {
    testConfigData(newQ, oldQ) {
      if (newQ != oldQ) {
        if (this.configType != "add") {
          let obj;
          obj = this.testoptions.find(
            (item) => item.value === this.testConfigData.config.test
          );
          if (obj) {
            this.selectOptions.value = obj.value;
            this.selectOptions.text = obj.value.replace(/^\w/, (c) =>
              c.toUpperCase()
            );
          }
        }
      }
    },
  },
  methods: {
    openDate(ref) {
      this.$refs[ref].$el.children[0].click();
    },
    confirm() {
      this.check = false;
      this.saveExistConfig();
      this.saveConfig();
    },
    isBetweenContentTag(element) {
      return element.textContent.trim() !== "";
    },
    getDesiredContent(contentType) {
      const tempDiv = document.createElement("div");
      const contentMapping = {
        testDesc: this.testConfigData.config.testDesc,
        testInst: this.testConfigData.config.testInst,
      };
      tempDiv.innerHTML = contentMapping[contentType] || "";
      const pTags = tempDiv.querySelectorAll("p");

      let endIndex = pTags.length;

      for (let i = pTags.length - 1; i >= 0; i--) {
        if (this.isBetweenContentTag(pTags[i])) {
          endIndex = i + 1;
          break;
        }
      }

      pTags.forEach((pTag, index) => {
        if (index >= endIndex && !pTag.textContent.trim()) {
          tempDiv.removeChild(pTag);
        }
      });

      if (contentType === "testDesc") {
        this.testConfigData.config.testDesc = tempDiv.innerHTML;
      } else if (contentType === "testInst") {
        this.testConfigData.config.testInst = tempDiv.innerHTML;
      }
    },
    setValue(val) {
      this.selectOptions.value = val.value;
      this.selectOptions.text = val.text;
      this.testConfigData.config.test = val.value;
    },
    enableVid() {
      if (this.testConfigData.config.enableProctoring) {
        this.testConfigData.config.enableCamera = true;
      }
    },
    async addConfig() {
      try {
        if (!this.testConfigData.config.dispCount) {
          this.testConfigData.config.dispCount = true;
        }
        if (!this.testConfigData.config.dispDuration) {
          this.testConfigData.config.dispDuration = true;
        }
        if (!this.testConfigData.config.includeEndTest) {
          this.testConfigData.config.includeEndTest = true;
        }

        this.errorstatus = false;
        this.getDesiredContent("testDesc");
        this.getDesiredContent("testInst");
        this.testConfigData.config.maxnoattempts =
          this.testConfigData.config.maxnoattempts.toString();
        let payload = {
          portion: "Config",
          name: this.testConfigData.configName,
          config: this.testConfigData.config,
        };
        // payload.config.timebetweenattempts = payload.config.timebnvalue;
        // CREATE A NEW CONFIG
        const res = await addConfig(payload);
        if (res.status == 200) {
          this.successModal("Configuration added successfully");
          this.addques1 = true;
          this.addques2 = true;
          this.$emit("config-created", res.data.data.ConfigID);
          this.closeModal();
        } else if (res.status === 409) {
          this.errorModal("Config name already exists");
        }
      } catch (error) {
        console.error(error);
      }
    },
    async saveExistConfig() {
      try {
        if (!this.testConfigData.config.dispCount) {
          this.testConfigData.config.dispCount = true;
        }
        if (!this.testConfigData.config.dispDuration) {
          this.testConfigData.config.dispDuration = true;
        }
        if (!this.testConfigData.config.includeEndTest) {
          this.testConfigData.config.includeEndTest = true;
        }
        this.getDesiredContent("testDesc");
        let payload = {
          configID: this.testConfigData.configID,
          config: this.testConfigData.config,
          name: this.testConfigData.configName,
          check: this.check,
        };
        // payload.config.timebetweenattempts = payload.config.timebnvalue;
        const res = await editConfig(payload);
        if (res.status == 200) {
          this.check = true;
          this.searchConfig = "";
          this.successModal("Configuration updated successfully");
          this.$bvModal.hide("expired-config");
          this.cautionModal = false;
          this.closeModal();
          this.addques1 = true;
          this.addques2 = true;
        } else if (res.status == 409) {
          this.cautionModal = true;
        }
      } catch (error) {
        console.error(error);
      }
    },
    populateData() {
      if (this.configType === "edit" || this.configType === "view") {
        this.testConfigData = JSON.parse(JSON.stringify(this.configData));
      } else if (this.configType === "add") {
        this.testConfigData = JSON.parse(
          JSON.stringify(this.defaultConfigValues)
        );
        this.testConfigData.config = JSON.parse(
          JSON.stringify(this.testConfigData.config)
        ); // Deep clone
        Object.assign(
          this.testConfigData.config,
          JSON.parse(JSON.stringify(this.configData.config))
        );
        this.dirtyCheckDescQuestion = false;
      }
      if (this.isExpireEdit) {
        this.tabIndex = 1;
      }
      this.getDosAndDonts();
      setTimeout(() => {
        this.showOverlay = false;
      }, 2000);
    },
    selectDosAndDonts(value, id) {
      for (let i in this.dosAndDontsList) {
        if (value) {
          if (
            this.testConfigData.config.dosAndDonts.length > 0 &&
            this.testConfigData.config.dosAndDonts[0].value == ""
          ) {
            this.testConfigData.config.dosAndDonts.splice(0, 1);
          }
          if (this.dosAndDontsList[i].value == id) {
            this.testConfigData.config.dosAndDonts.push({
              value: "",
              code: "",
            });
            this.testConfigData.config.dosAndDonts[
              this.testConfigData.config.dosAndDonts.length - 1
            ].code = this.dosAndDontsList[i].value;
            this.testConfigData.config.dosAndDonts[
              this.testConfigData.config.dosAndDonts.length - 1
            ].value = this.dosAndDontsList[i].description;
          }
        } else {
          for (let j in this.testConfigData.config.dosAndDonts) {
            if (this.testConfigData.config.dosAndDonts[j].code == id) {
              this.testConfigData.config.dosAndDonts.splice(j, 1);
            }
            if (this.testConfigData.config.dosAndDonts.length == 0) {
              this.testConfigData.config.dosAndDonts.push({
                value: "",
                code: "",
              });
            }
          }
        }
      }
    },
    async getDosAndDonts() {
      try {
        const res = await dosanddontslist();
        if (res.status == 200) {
          const data = res.data.data;
          for (let i in data) {
            if (data[i].type == "Dos and Donts") {
              this.dosAndDontsList = data[i].codeList;
              break;
            }
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    async enableEditing() {
      await getdosanddonts(this);
      this.configType = "edit";
    },
    previoustab() {
      this.tabIndex--;
    },
    validateInput(event) {
      const charCode = event.keyCode || event.which;
      const charTyped = String.fromCharCode(charCode);
      // Regular expression to allow only numbers and a single dot
      const regex = /^[0-9.]*$/;
      // If the typed character is not a number or dot, prevent the default behavior
      if (!regex.test(charTyped)) {
        event.preventDefault();
      }
    },
    setTimeAttempts() {
      if (this.configType != "view") {
        this.timeattempts = !this.timeattempts;
      }
    },
    validateText(val) {
      this.dirtyCheckDescQuestion = val;
    },
    addOptions() {
      this.testConfigData.config.dosAndDonts.push({
        value: "",
      });
    },
    checkCondition() {
      if (this.testConfigData.config.test == "") {
        this.testoptError = true;
      } else this.testoptError = false;

      this.openscreen(true);
      if (
        this.$v.testConfigData.config.testDesc.$invalid ||
        this.dirtyCheckDescQuestion
      ) {
        this.dirtyCheckDescQuestion = true;
      }
    },
    deleteOption(i) {
      this.testConfigData.config.dosAndDonts.splice(i, 1);
      this.$v.testConfigData.config.dosAndDonts.$reset();
    },
    updateQuestionContent(newContent) {
      this.testConfigData.config.testDesc = newContent;
    },
    changedaddQues(newval) {
      this.addques1 = newval;
    },
    focusOnStartDate() {
      this.$refs.startDate.$el.children[0].click();
    },
    focusOnEndDate() {
      this.$refs.endDate.$el.children[0].click();
    },
    validateText2(val) {
      this.dirtyCheckQuestion = val;
    },
    updateQuestionContent2(newContent) {
      this.testConfigData.config.testInst = newContent;
    },
    changedaddQues2(newval) {
      this.addques2 = newval;
    },
    closeTime() {
      this.timeattempts = false;
    },
    closeModal() {
      this.testConfigData = { ...this.defaultConfigValues };
      this.$v.testConfigData.$reset();
      this.dirtyCheckQuestion = false;
      this.dirtyCheckDescQuestion = false;
      this.selectOptions = {
        text: "",
        value: "",
      };
      this.$emit("close-modal");
    },
    openscreen(flag) {
      if (
        this.$v.testConfigData.config.testDesc.$invalid ||
        this.dirtyCheckDescQuestion
      ) {
        this.dirtyCheckDescQuestion = true;
      }
      this.$v.testConfigData.config.testOrg.$touch();
      this.$v.testConfigData.configName.$touch();
      if (
        (!this.dirtyCheckDescQuestion ||
          !this.$v.testConfigData.config.testDesc.$invalid) &&
        !this.$v.testConfigData.config.testOrg.$invalid &&
        !this.$v.testConfigData.configName.$invalid &&
        this.testConfigData.config.test != ""
      ) {
        if (flag) {
          this.tabIndex++;
        }
        this.fieldsinvalidosd = false;
      } else {
        this.fieldsinvalidosd = true;
      }
    },
    questionbehaviour(flag) {
      this.$v.testConfigData.config.passingPercentage.$touch();
      this.$v.testConfigData.config.negativeMarkValue.$touch();
      this.$v.testConfigData.config.maxnoattempts.$touch();
      this.$v.testConfigData.config.buffertime.$touch();

      this.$v.testConfigData.config.quesPerScreen.$touch();
      this.$v.testConfigData.config.timebnvalue.$touch();
      this.$v.testConfigData.config.timebnsel.$touch();

      this.$v.testConfigData.config.testDuration.$touch();
      this.$v.testConfigData.config.openTestdt.$touch();
      this.$v.testConfigData.config.closeTestdt.$touch();

      if (
        !this.$v.testConfigData.config.passingPercentage.$invalid &&
        !this.$v.testConfigData.config.negativeMarkValue.$invalid &&
        !this.$v.testConfigData.config.maxnoattempts.$invalid &&
        !this.$v.testConfigData.config.buffertime.$invalid &&
        !this.$v.testConfigData.config.timebnsel.$invalid &&
        !this.$v.testConfigData.config.timebnvalue.$invalid &&
        !this.$v.testConfigData.config.quesPerScreen.$invalid &&
        !this.$v.testConfigData.config.testDuration.$invalid &&
        !this.$v.testConfigData.config.openTestdt.$invalid &&
        !this.$v.testConfigData.config.closeTestdt.$invalid &&
        this.$v.testConfigData.config.closeTestdt.isDateValid &&
        !this.timeDiffMinutes
      ) {
        if (flag) {
          this.tabIndex++;
        }
        this.fieldsinvalidqb = false;
      } else {
        this.fieldsinvalidqb = true;
      }
    },
    systemSetup(flag) {
      this.$v.testConfigData.config.screenCapture.$touch();
      this.$v.testConfigData.config.communicationTestAttempts.$touch();
      if (
        !this.$v.testConfigData.config.screenCapture.$invalid &&
        !this.$v.testConfigData.config.communicationTestAttempts.$invalid
      ) {
        this.fieldsinvalidss = false;
        if (this.testConfigData.config.enableProctoring) {
          if (this.testConfigData.config.enableCamera && flag) {
            this.tabIndex++;
          }
        } else if (flag) {
          this.tabIndex++;
        }
      } else {
        this.fieldsinvalidss = true;
      }
    },
    checkCommunicationTestAttempts() {
      if (!this.testConfigData.config.communicationTest) {
        this.testConfigData.config.communicationTestAttempts = null;
      }
    },
    checkMaxAttempts() {
      if (parseInt(this.testConfigData.config.maxnoattempts) < 2) {
        this.testConfigData.config.timebnsel = "";
        this.testConfigData.config.timebnvalue = "";
      }
    },
    checkConfigValidations() {
      this.openscreen(false);
      this.questionbehaviour(false);
      this.systemSetup(false);
      this.$v.testConfigData.config.dosAndDonts.$touch();
      if (
        !this.fieldsinvalidosd &&
        !this.fieldsinvalidqb &&
        !this.fieldsinvalidss &&
        !this.$v.testConfigData.config.dosAndDonts.$invalid
      ) {
        if (
          this.testConfigData.config.timebnsel != "" &&
          this.testConfigData.config.timebnsel != null
        ) {
          if (this.testConfigData.config.timebnsel == "hrs") {
            this.testConfigData.config.timebetweenattempts =
              this.testConfigData.config.timebnvalue * 60;
          } else if (this.testConfigData.config.timebnsel == "days") {
            this.testConfigData.config.timebetweenattempts =
              this.testConfigData.config.timebnvalue * 1440;
          } else {
            this.testConfigData.config.timebetweenattempts =
              this.testConfigData.config.timebnvalue;
          }
          this.testConfigData.config.timebetweenattempts =
            this.testConfigData.config.timebetweenattempts.toString();
        }
        this.testConfigData.config.openTestdt = convertTime(
          this.testConfigData.config.openTestdt,
          "utc"
        );
        this.testConfigData.config.closeTestdt = convertTime(
          this.testConfigData.config.closeTestdt,
          "utc"
        );
        if (this.configType === "add") {
          this.addConfig();
        } else {
          this.saveExistConfig();
        }
      } else {
        this.errorstatus = true;
      }
    },
    allowFromToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to 0 for accurate comparison
      return date < today; // Compare the input date with today's date
    },
    allowPrevDates(date) {
      const startDate = this.testConfigData.config.openTestdt;
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      if (startDate) {
        const start = new Date(startDate);
        start.setHours(0, 0, 0, 0);
        return date < start || date < today;
      }
      return date < today;
    },
    disableTime(date) {
      const currentTime = new Date();
      const selectedDate = new Date(date);
      // Set seconds and milliseconds to 0
      selectedDate.setSeconds(0);
      selectedDate.setMilliseconds(0);
      if (selectedDate.getTime() < currentTime.getTime()) {
        return true; // Disable if selected time is before or equal to current time
      }
    },
  },
};
</script>
<style>
.cj-test-section-tabs .tab-pane {
  height: calc(100vh - 200px);
  overflow-x: hidden;
  overflow-y: auto;
}

.cj-test-section-tabs .nav-tabs {
  background: #faf9f9;
  border: 1px solid #e7e7e7;
  border-radius: 10px;
  width: 100%;
}

.cj-test-section-tabs .nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: white;
  background: #72738e;
  border-radius: 10px;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
  padding: 7px 79px;
  position: relative;
}

.cj-test-section-tabs .nav-tabs .nav-link {
  font-weight: var(--weight-LM);
  font-size: var(--size-14);
  padding: 7px 73px;
  position: relative;
  min-width: 150px;

  color: var(--btn-border);
  margin-bottom: none;
  border: none;
  border-top-left-radius: none;
  border-top-right-radius: none;
  text-align: center;
}
.prev-btn {
  position: absolute;
  bottom: 10px;
  left: 9px;
}
.testconfig-topDiv-name > .inputField {
  border: 0.7px solid var(--input-border);
  border-radius: 3px !important;
  font-size: 14px;
  background: var(--bg-inputfield);
  color: #6d6d6d;
  box-sizing: border-box;
  padding: 0.5rem 0.75rem;
  padding-right: 2rem;
  height: calc(1.5em + 0.75rem + 2px);
}
.add-btn-tc .btn-secondary {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 5px 10px 5px 10px;
  gap: 10px;

  background: #20639b;
  border-radius: 40px;
}
.add-btn-tc .btn-secondary:hover {
  color: var(--bg-white);
  background-color: #20639b;
  box-shadow: 0px 0px 0px 0px rgba(32, 99, 155, 0.2),
    2px 3px 7px 0px rgba(32, 99, 155, 0.2),
    7px 10px 12px 0px rgba(32, 99, 155, 0.17),
    44px 63px 22px 0px rgba(32, 99, 155, 0);
}
.add-btn-tc .btn-secondary:not(:disabled):not(.disabled):active,
.add-btn-tc .btn-secondary:not(:disabled):not(.disabled).active,
.add-btn-tc .show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: #20639b;
  border-color: #20639b;
}
.add-btn-tc-txt {
  font-family: "Montserrat", sans-serif, sans-serif;
  font-weight: 600;
  font-size: 13px;
  /* identical to box height */
  display: flex;
  align-items: center;

  color: #ffffff;
}
.fdf-add-container-tc
  .custom-radio.b-custom-control-sm
  .custom-control-label::after {
  position: absolute;
  top: 0.9px;
  left: -22px;
  display: block;
  width: 16px;
  height: 20px;
  content: "";
  background: 49% / 55% 65% no-repeat;
}

.fdf-add-container-tc
  .custom-radio
  .custom-control-input:checked
  ~ .custom-control-label::after {
  background-image: url("../../../assets/img/feedbackform/radiobtn.svg");
}

.fdf-add-container-tc
  .custom-control-input:checked
  ~ .custom-control-label::before {
  color: #fff;
  border-color: var(--bluetheme);
  background-color: #fff;
}

#startdatetimeconfig {
  width: 100%;
}

.time-div-tc-dpd
  .btns-stckd
  .btn-secondary:not(:disabled):not(.disabled):active,
.time-div-tc-dpd
  .btns-stckd
  .btn-secondary:not(:disabled):not(.disabled).active,
.time-div-tc-dpd .btns-stckd .show > .btn-secondary.dropdown-toggle {
  color: #3a3c40 !important;
  border-color: #c8d9e5 !important;
  background-color: #c8d9e5 !important;
  font-size: 14px;
  font-weight: 500;
}
.error-dp-tc .mx-input {
  border: 1px solid red !important;
  border-radius: 5px;
}
</style>
